export default "__VITE_ASSET__CbQJwa1b__"